<template>
    <div class="scrolls-enabled">
        <div v-for="(button, index) in buttons" v-bind:key="index" class="nav-item-wrap">
            <router-link v-if="showByRole(button)" :to="{ name: button.path }" class="nav-link-item">
                <div class="nav-link-content">
                    <span class="icon-panel">
                        <img :src="button.img" aria-hidden="true">
                    </span>
                    <div v-if="isExpanded" class="nav-link-label text-uppercase">
                        {{ button.name }}
                    </div>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LeftNavMenu",
        props: {
            isExpanded: Boolean,
            buttons: {
                type: Array,
                required: true
            },
        },
        methods: {
            showByRole(button) {
                if (!button.path)
                    return false;

                if (button.isAdmin)
                    return this.$store.getters.isAdmin;
                return true;
            }
        }
    }
</script>

<style scoped>
    .icon-panel {
        width: 58px;
        height: 58px;
        flex: 0 0 58px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        border-radius: 8px;
        color: #ffffff;
        font-size: 1rem;
        line-height: 1;
    }

    .icon-panel img {
        width: 42px;
        height: 42px;
        display: block;
        object-fit: contain;
        filter: brightness(0) invert(1);
        opacity: 0.92;
    }

    a {
        color: white;
    }

    a:hover {
        color: white;
    }

    .nav-item-wrap {
        width: 100%;
        padding: 0;
        margin-bottom: 0;
    }

    .nav-link-item {
        display: block;
        width: 100%;
        transition: background-color 0.2s ease, transform 0.2s ease;
    }

    .nav-link-item:hover,
    .router-link-active {
        background: rgba(255, 255, 255, 0.12);
    }

    .nav-link-item:active {
        transform: translateY(1px);
    }

    .nav-link-content {
        min-height: 58px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 12px;
        padding: 0 14px;
    }

    .nav-link-label {
        min-width: 0;
        flex: 1;
        overflow: hidden;
        text-align: left;
        font-size: 0.78rem;
        font-weight: 600;
        letter-spacing: 0;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .scrolls-enabled {
        max-height: calc(100vh - 64px);
        overflow-y: auto;
        padding-bottom: 14px;
    }

    @media (max-width: 767.98px) {
        .scrolls-enabled {
            max-height: calc(min(70dvh, 520px) - 54px);
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            gap: 8px;
            padding: 0 10px 12px;
        }

        .nav-item-wrap {
            width: auto;
            flex: 1 1 92px;
            min-width: 92px;
            max-width: 180px;
            padding: 0;
            margin-bottom: 0;
        }

        .nav-link-content {
            min-height: 72px;
            flex-direction: column;
            justify-content: center;
            gap: 4px;
            padding: 8px 6px;
        }

        .nav-link-label {
            width: 100%;
            text-align: center;
            font-size: 0.68rem;
        }
    }
</style>
